import DescriptionOnlyFormValues from "../ReusableFormValues/DescriptionOnlyFormValues";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { registerOfDirectorsDocumentTypesArray } from "./constants";

export type Props = {
  readonly: boolean;
  documentName?: string;
};

const RegisterOfDirectorsFormValues = ({ readonly, documentName = "" }: Props) => {
  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={registerOfDirectorsDocumentTypesArray}
        placeholder="Select a register of directors document type"
        name="secondaryDocumentType"
        label="Document sub-type"
        documentName={documentName}
      />
      <DescriptionOnlyFormValues readonly={readonly} />
    </>
  );
};

export default RegisterOfDirectorsFormValues;
